export default {
  label: {
    statusHeader: 'Status',
    transitionsHeader: 'Transitions',
  },
};
